package com.parmartechnologies.core.constant
const val SERVER_PORT = 8080

enum class Environment (val value:String) {
    dev("dev"),
    qa("qa"),
    prod("prod")
}